<template>
  <footer>
    <div class="bg-gray-800 py-6 text-gray-400 px-6 sm:px-10">
      <div class="container mx-auto px-4">
        <div class="-mx-4 flex flex-wrap justify-between">
          
          <!-- LEFT SECTION -->
          <div class="px-4 my-4 w-full xl:w-1/2">
            <a href="/" class="block w-40 sm:w-56 mb-6 sm:mb-10">
              <img src="../assets/logo.png" alt="PH Web Development Logo" class="w-full h-auto">
            </a>
            <p class="text-justify text-sm sm:text-base leading-relaxed">
              PH Web Development Services is a Freelance Web Development Group
              that aims to build websites for every business—small, medium, or large—
              at an affordable package.
            </p>

            <!-- Address -->
            <a href="https://maps.app.goo.gl/Ch6uQbnXUdu2Mbke9"
               class="flex items-start gap-2 mt-4 text-sm sm:text-base leading-snug">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 flex-shrink-0 mt-0.5 fill-current text-gray-400" viewBox="0 0 576 512">
                <path d="M541 229.16 512 206.63V56a24 24 0 0 0-24-24H424a24 24 0 0 0-24 24v36.6L318.47 43a35.73 35.73 0 0 0-45 0L35 229.16a12 12 0 0 0-1.6 16.9l21.4 26.5a12 12 0 0 0 16.9 1.6L96 234.8V456a24 24 0 0 0 24 24H456a24 24 0 0 0 24-24V234.8l24.3 19.4a12 12 0 0 0 16.9-1.6l21.4-26.5a12 12 0 0 0-1.6-16.94z"/>
              </svg>
              2131 Angeles St. Fortune Village 1, Brgy. Gen. T. de Leon,
              Valenzuela City, NCR
            </a>

            <!-- Emails -->
            <div class="mt-4 space-y-2 text-sm sm:text-base">
              <a href="mailto:devops@phwebdevservices.com" target="_blank"
                 class="block flex items-center gap-2 hover:text-red-500 transition-colors duration-200">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 fill-current" viewBox="0 0 512 512">
                  <path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"/>
                </svg>
                devops@phwebdevservices.com
              </a>
              <a href="mailto:sales@phwebdevservices.com" target="_blank"
                 class="block flex items-center gap-2 hover:text-red-500 transition-colors duration-200">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 fill-current" viewBox="0 0 512 512">
                  <path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"/>
                </svg>
                sales@phwebdevservices.com
              </a>
              <a href="mailto:support@phwebdevservices.com" target="_blank"
                 class="block flex items-center gap-2 hover:text-red-500 transition-colors duration-200">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 fill-current" viewBox="0 0 512 512">
                  <path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"/>
                </svg>
                support@phwebdevservices.com
              </a>
            </div>

            <!-- Phone Numbers -->
            <div class="mt-4 space-y-2 text-sm sm:text-base">
              <a href="tel:09303412561" class="block flex items-center gap-2 hover:text-red-500 transition-colors duration-200">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 fill-current" viewBox="0 0 384 512">
                  <path d="M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zm96 160a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"/>
                </svg>
                0930 341 2561
              </a>
              <a href="tel:09915785155" class="block flex items-center gap-2 hover:text-red-500 transition-colors duration-200">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 fill-current" viewBox="0 0 384 512">
                  <path d="M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zm96 160a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"/>
                </svg>
                0991 578 5155
              </a>
              <a href="tel:09915325699" class="block flex items-center gap-2 hover:text-red-500 transition-colors duration-200">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 fill-current" viewBox="0 0 384 512">
                  <path d="M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zm96 160a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"/>
                </svg>
                0991 532 5699
              </a>
            </div>
          </div>

          <!-- RIGHT SECTION -->
          <div class="px-4 my-4 w-full sm:w-auto xl:w-1/2 text-center sm:text-right">
            <h2 class="inline-block text-xl sm:text-2xl pb-3 sm:pb-4 mb-4 border-b-4 border-blue-600">Connect With Us</h2>
            <div class="flex sm:justify-end justify-center flex-wrap gap-2">
              <!-- ✅ Social Media Icons -->
              <a href="https://www.facebook.com/phwebdevservices" target="_blank" class="inline-flex items-center justify-center h-8 w-8 border border-gray-100 rounded-full hover:text-blue-400 hover:border-blue-400">
                <!-- Facebook -->
                <svg class="w-4 h-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                  <path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"/>
                </svg>
              </a>
              
              <a href="#" class="inline-flex items-center justify-center h-8 w-8 border border-gray-100 rounded-full hover:text-gray-300 hover:border-gray-300">
                <!-- GitHub -->
                <svg class="w-4 h-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512">
                  <path d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.1 0-5.2-1.6-5.2-3.6 0-2 2.3-3.6 5.2-3.6 3 0 5.2 1.6 5.2 3.6zm-32.2-10.9c-.7 1.6-2.8 2.3-4.7 1.6-2-.7-2.8-2.8-2-4.4.7-1.6 2.8-2.3 4.7-1.6 1.9 .7 2.7 2.8 2 4.4zm44.2-1.7c-2.9 .7-5.9-.7-6.6-3.2-.7-2.5 1.2-5.1 4.1-5.8 2.9-.7 5.9 .7 6.6 3.2 .7 2.5-1.2 5.1-4.1 5.8zM244 8C109.5 8 0 117.5 0 252c0 108.9 70.5 201.4 168.4 234.1 12.3 2.3 16.8-5.3 16.8-11.8 0-5.8-.2-25.2-.4-45.6-68.4 14.9-82.9-29.5-82.9-29.5-11.2-28.7-27.4-36.3-27.4-36.3-22.4-15.3 1.7-15 1.7-15 24.8 1.7 37.8 25.4 37.8 25.4 22 37.7 57.7 26.8 71.8 20.5 2.3-15.9 8.6-26.8 15.6-33-54.6-6.2-112-27.4-112-121.9 0-26.9 9.6-49 25.4-66.3-2.5-6.2-11-31.3 2.4-65.2 0 0 20.7-6.6 67.8 25.4 19.7-5.5 40.8-8.3 61.8-8.4 21 .1 42.1 2.9 61.9 8.4 47-32 67.7-25.4 67.7-25.4 13.4 33.9 4.9 59 2.4 65.2 15.9 17.3 25.4 39.4 25.4 66.3 0 94.7-57.5 115.6-112.2 121.7 8.9 7.6 16.8 22.5 16.8 45.2 0 32.6-.3 59-.3 67 0 6.6 4.4 14.3 16.9 11.8C425.5 453.4 496 360.9 496 252 496 117.5 386.5 8 252 8z"/>
                </svg>
              </a>
              <!-- 🌟 Viber -->
<a href="viber://chat?number=09915785155" target="_blank"
   class="inline-flex items-center justify-center h-8 w-8 border border-gray-100 rounded-full
          hover:text-purple-500 hover:border-purple-500">
  <svg class="w-4 h-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M256 0C114.6 0 0 114.6 0 256c0 54.8 17.3 105.6 46.7 
             146.7L32 480l80.3-14.6C151.4 494.7 201.2 512 256 512
             397.4 512 512 397.4 512 256S397.4 0 256 0zm92.7 
             342.2c-4.6 13-27.3 24.4-38.1 25.1-10.1.6-22.7.9-36.7-5.7
             -30.7-14.5-101-89.2-118.2-125.3-17.3-36.2-15.1-48.4-12.8-58.1
             2.4-9.8 13.1-23.5 25.3-23.7 6.5-.1 12.4 0 17.9 0 4.8 0 11.4-1.8
             17.8 13.6 6.3 15.3 21.4 52.7 23.2 56.6 1.8 3.9 3.1 8.5 0 13.8
             -3.1 5.3-4.7 8.5-9.3 13.1-4.6 4.6-9.7 10.2-4.1 19.9 5.6 9.7 
             24.9 41 53.6 66.2 29.6 26 54.2 34.1 63.8 37.9 9.7 3.9 15.3 
             3.3 20.7-2.1 5.3-5.3 23.6-27.5 29.9-37 6.3-9.6 12.3-8 20.7-4.6
             8.4 3.5 52.9 25.1 61.9 29.6 9 4.5 15 6.8 17.1 10.5 2.1 3.7 2.1
             21.9-2.5 34.9z"/>
  </svg>
</a>


<!-- 🌟 WhatsApp -->
<a href="https://wa.me/09303412561" target="_blank"
   class="inline-flex items-center justify-center h-8 w-8 border border-gray-100 rounded-full
          hover:text-green-500 hover:border-green-500">
  <svg class="w-4 h-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
    <path d="M380.9 97.1C339 35.9 273.7 0 201.7 0 90.7 0 0 90.7 0 
             201.7c0 35.6 9.3 70.3 27 101.1L0 448l149.5-27.1c29 15.9 
             61.6 24.3 95.5 24.3h.1c111 0 201.7-90.7 201.7-201.7 0-53.8
             -21.1-104.3-65.9-146.4zM201.7 415.6c-29.7 0-58.8-8-84-23.1l-6-3.6
             -88.8 16.1 16.9-86.4-3.9-6.3c-17.4-28.1-26.6-60.5-26.6-94.6
             0-96.7 78.7-175.4 175.4-175.4 46.9 0 90.9 18.3 124 51.4
             33.1 33.1 51.4 77.1 51.4 124 0 96.7-78.7 175.4-175.4 175.4zm99.4
             -131.6c-5.4-2.7-31.7-15.6-36.6-17.3-4.9-1.8-8.5-2.7-12.1 2.7
             -3.6 5.4-13.9 17.3-17 20.9-3.1 3.6-6.3 4-11.7 1.3-31.7-15.9
             -52.4-28.4-73.3-64.1-5.5-9.5 5.5-8.8 15.9-29.2 1.8-3.6 .9-6.7-.5
             -9.3-1.3-2.7-12.1-29.2-16.6-40.1-4.4-10.6-8.9-9.1-12.1-9.3-3.1-.2
             -6.7-.2-10.3-.2s-9.3 1.3-14.1 6.7c-4.9 5.4-18.5 18-18.5 43.9s19 
             50.9 21.6 54.4c2.7 3.6 37.4 57.1 90.6 80 12.7 5.5 22.6 8.7 30.3
             11.1 12.7 4 24.2 3.4 33.3 2 10.2-1.5 31.7-13 36.1-25.6
             4.5-12.7 4.5-23.5 3.1-25.6-1.3-2.1-4.9-3.6-10.3-6.3z"/>
  </svg>
</a>


            </div>
          </div>

        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
// No JS needed
</script>

<style scoped>
/* Tailwind handles most styling */
</style>
